'use strict';

//Returns a slice of an array
intellidealerAppCoreModule.filter('sliceArray', function () {
  return function(array, start, end) {
    return array.slice(start, end);
  };
});